import { useEffect, useState } from 'react';
import { useRecoilState } from 'recoil';
import { Link } from 'react-router-dom';
import style from './historyPopup.module.css';
import Pagination from '../../widgets/Pagination';
import { showHistoryAtom } from '../../../store';
import { getWalletHistory } from '../../../utils/net'
import { trackEvent } from '../../../utils/trackEvent'
import walletimg from '../../../assets/wallet.png'
import groupWalletimg from '../../../assets/groupWallet.png'

const filterArr = ['All', 'In', 'Out'];


function HistoryPopup({ wallet }) {
    const [, setShowHistory] = useRecoilState(showHistoryAtom);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [showFilter, setShowFilter] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [currentFilterIndex, setCurrentFilterIndex] = useState(0);
    const [totalHistoryList, setTotalHistoryList] = useState([]);
    const [inHistoryList, setInHistoryList] = useState([]);
    const [outHistoryList, setOutHistoryList] = useState([]);
    const [filterList, setFilterList] = useState([]);
    const [userWallet, setUserWallet] = useState(wallet.userInitial)

    const currentPageList = filterList.slice((currentPage - 1) * 12, currentPage * 12);

    const fecth = async (ownerType) => {
        const baseParam = {
            owner_type: ownerType,
            query_info: {}
        }
        if (ownerType === 'group') {
            baseParam.query_info.group_uuid = localStorage.getItem('group_uuid')
        } else {
            baseParam.query_info.user_uuid = localStorage.getItem('user_uuid')
        }

        const [chargeData, expenseData] = await Promise.all([
            getWalletHistory('Charge', baseParam),
            getWalletHistory('Expense', baseParam),
        ]);

        const chargeList = chargeData?.data?.data?.reverse();
        const expenseList = expenseData?.data?.data?.reverse();
        // console.log(expenseList, chargeList);
        const total = mergeSortArray(chargeList, expenseList);
        setTotalHistoryList(total);
        setInHistoryList(chargeList);
        setOutHistoryList(expenseList);
        setFilterList(total);
        setTotalPages(Math.ceil(total.length / 12));
        setIsLoading(false);
    }

    useEffect(() => {
        setIsLoading(true);
        fecth(userWallet ? 'user' : 'group')
    }, [userWallet])



    useEffect(() => {
        setTotalPages(Math.ceil(filterList.length / 12));
        setCurrentPage(1);
    }, [currentFilterIndex]);

    const handleClose = () => {
        setShowHistory(false);
    };
    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };


    const mergeSortArray = (arr1, arr2) => {
        const mergedArray = [];
        let i = 0;
        let j = 0;
        while (i < arr1.length && j < arr2.length) {
            if (arr1[i].date >= arr2[j].date) {
                mergedArray.push(arr1[i]);
                i++;
            } else {
                mergedArray.push(arr2[j]);
                j++;
            }
        }
        while (i < arr1.length) {
            mergedArray.push(arr1[i]);
            i++;
        }
        while (j < arr2.length) {
            mergedArray.push(arr2[j]);
            j++;
        }
        return mergedArray;
    };

    const checkfilterType = (index) => {
        setShowFilter(false);
        setCurrentFilterIndex(index);
        index === 0 && setFilterList(totalHistoryList);
        index === 1 && setFilterList(inHistoryList);
        index === 2 && setFilterList(outHistoryList);
    };

    const handlerSwitch = () => {
        if (!wallet.group) return
        setUserWallet(pre => !pre)
        setCurrentFilterIndex(0)
        setShowFilter(false)
    }
    return (
        <>
            <div className={style.overlay} onClick={handleClose} />
            {
                isLoading ? <div className={style.loadingBox}>
                    <div className={style.loadingContainer}>
                        <div className={style.loading} />
                        <div>Loading...</div>
                    </div>
                </div> : <div className={style.popupContainer}>
                    <div className={style.popup}>
                        <div className={style.popupHeader}>
                            <h2>Account Activity History</h2>
                            <div className={style.switchBox} onClick={handlerSwitch}>
                                {wallet.group &&
                                    <img
                                        style={{
                                            opacity: userWallet ? 0.5 : 1,
                                            zIndex: userWallet ? 1 : 2,
                                        }}
                                        className={style.groupSvg}
                                        src={groupWalletimg}
                                        alt="groupWalletimg" />
                                }
                                <img
                                    style={{
                                        opacity: userWallet ? 1 : 0.5,
                                        zIndex: userWallet ? 2 : 1,
                                    }}
                                    className={style.userSvg}
                                    src={walletimg}
                                    alt="walletimg" />
                                <span>{userWallet ? `Personal` : 'Group'} </span>
                            </div>
                            <div className={style.filterWrapper}>
                                <div
                                    onPointerDown={() => {
                                        setShowFilter(pre => !pre);
                                    }}
                                    className={style.filter}
                                >
                                    {filterArr[currentFilterIndex]}

                                    <div className={`${showFilter ? style.show : ''} ${style.filterBox}`}>
                                        {
                                            filterArr.map((item, index) => (
                                                <div
                                                    onPointerDown={() => {
                                                        trackEvent(`Wallet - History - ${filterArr[index]}: Switch`, { filterArr:filterArr[index] })
                                                        checkfilterType(index);
                                                    }}
                                                    className={style.filterItem}
                                                    key={index}
                                                >
                                                    {item}
                                                </div>
                                            ))
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={style.boder} />
                        <div className={style.popupBody}>
                            <div className={style.popupTags}>
                                {['Date', 'Credits', 'Source'].map((item, index) => <div className={style.popupTagsItem} key={index}>{item}</div>)}
                            </div>
                            {totalPages > 0 ? currentPageList.map((item) => (
                                <div className={style.popupLine} key={item.date}>
                                    <div>{`${item.date.split('T')[0]} ${item.date.split('T')[1].slice(0, 5)}`}</div>
                                    <div>{item.amount / 10}</div>
                                    {item.target
                                        ? !['license', 'private'].includes(item.target)
                                            ? (
                                                <Link
                                                    to={`/chatavatar/${item.detail}`}
                                                    target="_blank"
                                                    className={style.historyTaget}
                                                >
                                                    {item.target}
                                                </Link>
                                            )
                                            : <div className={style.historySource}>{item.target}</div>
                                        : <div className={style.historySource}>{item.source}</div>}
                                </div>
                            )) : <div className={style.empty}>There are currently no records available</div>
                            }
                        </div>
                    </div>
                    <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={handlePageChange}
                    />
                </div>
            }


        </>

    );
}

export default HistoryPopup;
